/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Use this carefully, shouldn't be an excuse for laziness with the proper types.
 */
export type AnyType = any;

/**
 * A JSON object without further classification.
 */
export type JsonType = any;
